import { useTranslation } from 'react-i18next';

import type { ActivityEvent } from '@/entities/history/types';

import { useDescribeEvent } from './useDescribeEvent';

/** `Alice` + the event sentence, for the card History and the board Activity feed. */
export function EventText({ event }: { event: ActivityEvent }) {
  const { t } = useTranslation();
  const describe = useDescribeEvent();
  return (
    <>
      <strong>{event.actor.name ?? t('history.unknownActor')}</strong> {describe(event)}
    </>
  );
}
